<template>
  <el-row class="tac">
    <!-- <h5>自定义颜色</h5> -->
    <el-menu
      :default-active="activityId"
      class="el-menu-vertical-demo"
      @open="handleOpen"
      @close="handleClose"
      @select="handleSelect"
      background-color="#0d0d0d"
      text-color="#999999"
      active-text-color="#ff7800">
      <el-submenu v-for="(s) in tree" v-bind:key="s.id" :index="convertNumToStr(s.id)">
        <template slot="title">
          <i class="el-icon-location"></i>
          <span>{{ s.years }}</span>
        </template>
        <el-submenu v-for="(t) in s.types" v-bind:key="t.id" :index="convertNumToStr(t.id)">
          <template slot="title">{{ t.title }}</template>
          <el-menu-item v-for="(a) in t.events" v-bind:key="a.id" :index="convertNumToStr(a.id)">{{ a.title }}</el-menu-item>
        </el-submenu>
      </el-submenu>
      <!-- test -->
      <!-- <el-submenu index="1">
        <template slot="title">
          <i class="el-icon-location"></i>
          <span>导航一</span>
        </template>
        <el-menu-item-group>
          <template slot="title">分组一</template>
          <el-menu-item index="1-1">选项1</el-menu-item>
          <el-menu-item index="1-2">选项2</el-menu-item>
        </el-menu-item-group>
        <el-menu-item-group title="分组2">
          <el-menu-item index="1-3">选项3</el-menu-item>
        </el-menu-item-group>
        <el-submenu index="1-4">
          <template slot="title">选项4</template>
          <el-menu-item index="1-4-1">选项1</el-menu-item>
        </el-submenu>
      </el-submenu>
      <el-menu-item index="2">
        <i class="el-icon-menu"></i>
        <span slot="title">导航二</span>
      </el-menu-item>
      <el-menu-item index="3" disabled>
        <i class="el-icon-document"></i>
        <span slot="title">导航三</span>
      </el-menu-item>
      <el-menu-item index="4">
        <i class="el-icon-setting"></i>
        <span slot="title">导航四</span>
      </el-menu-item> -->
    </el-menu>
  </el-row>
</template>

<script>
import { activities } from '@/api'

export default {
  name: 'ActivityTree',
  data () {
    return {
      // defaultActive: this.$route.params.id,
      tree: []
    }
  },
  props: [ 'activityId' ],
  methods: {
    getTree () {
      activities().then(response => {
        if (response && response.data && response.data.success === true) {
          // console.log(response.data.data)
          this.tree = response.data.data
        } else if (response && response.data && response.data.success === false) {
        }
      })
    },
    handleOpen (key, keyPath) {
      // console.log(key, keyPath)
    },
    handleClose (key, keyPath) {
      // console.log(key, keyPath)
    },
    handleSelect (key, keyPath) {
      // console.log(key)
      this.$router.push({ path: this.redirect || '/activity/' + keyPath[2] })
    },
    convertNumToStr (num) {
      return '' + num
    }
  },
  created () {
    this.getTree()
  }
}
</script>

<style lang="less">
  .el-menu {
    border-right: 0px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/ActivityTree.vue